/**
 * The A/B testing storage module.
 */

import { storage as localStorageWrapper } from '@/helpers/storage'
import { StorageKeys } from '@/helpers/storage.keys'

import type { ExperimentsDict } from './types'

export function clientId(): string | null {
  return localStorageWrapper.getItem(StorageKeys.abCid)
}

export function setClientId(client_id: string): void {
  localStorageWrapper.setItem(StorageKeys.abCid, client_id)
}

export function getExperiments(): ExperimentsDict {
  const data = localStorageWrapper.getItem(StorageKeys.abData)
  if (data) {
    const experiments = JSON.parse(data)
    return experiments
  }
  return {}
}

export function setExperiments(experiments: ExperimentsDict): void {
  localStorageWrapper.setItem(StorageKeys.abData, JSON.stringify(experiments))
}

export function hasExperiment(experiment: string): boolean {
  const experiments = getExperiments()
  return experiments.hasOwnProperty(experiment)
}

export function setExperiment(experiment: string, variant: string): void {
  const experiments = getExperiments()
  // Note: there is special '_EXCLUDED_' value (user is filtered out of the experiment).
  experiments[experiment] = variant
  setExperiments(experiments)
}

export function variant(experiment: string): string | null {
  let variant = null

  const experiments = getExperiments()
  if (experiments.hasOwnProperty(experiment)) {
    variant = experiments[experiment]
  }

  return variant
}

export * as storage from './storage'
